import { Box, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { AsyncAutoCompleteNew } from "../../../async-auto-complete/AsyncAutoCompleteNew";

type FilterPsychologistsProps = {
    entityForm: UseFormReturn;
    disabled?: boolean;
};

export const FilterPsychologists = ({ entityForm, disabled }: FilterPsychologistsProps) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                <AsyncAutoCompleteNew
                    entityForm={entityForm as unknown as UseFormReturn}
                    fieldName="age_groups"
                    placeholder="Idade"
                    enabled={true}
                    disabled={disabled}
                    recordsOptions={{
                        entity: "age_groups",
                        fieldsToQuery: "*",
                        labelKey: "name",
                        sort: "id",
                    }}
                />
                <AsyncAutoCompleteNew
                    entityForm={entityForm as unknown as UseFormReturn}
                    fieldName="disorder_specialization"
                    placeholder="Perturbação"
                    enabled={true}
                    disabled={disabled}
                    recordsOptions={{
                        entity: "disorders",
                        fieldsToQuery: "*",
                        labelKey: "name",
                        sort: "name",
                    }}
                />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2, alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="caption" color="primary">
                    (Selecione a idade, a perturbação e/ou psicólogo para filtrar)
                </Typography>
            </Box>
        </Box>
    );
};
